module.exports = __webpack_public_path__ + "static/media/AvantGardeMedium.42efa819.svg";